import React from "react";

function EventLocation() {
  return (
    <span className="anticon anticon-live">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 13 16"
      >
        <g
          fill="none"
          fillRule="evenodd"
          transform="translate(-136 -5)"
        >
          <g fillRule="nonzero" stroke="currentColor" strokeWidth="0.8">
            <path d="M143.368 18.877l-.868.748-.868-.748c-3.1-2.673-4.674-5.04-4.674-7.237 0-3.11 2.457-5.473 5.542-5.473 3.084 0 5.541 2.362 5.541 5.473 0 2.198-1.574 4.564-4.673 7.237z"></path>
            <path d="M142.5 9.334a2.375 2.375 0 110 4.75 2.375 2.375 0 010-4.75z"></path>
          </g>
        </g>
      </svg>
    </span>
  );
}

export default EventLocation;
